import { formatNumber } from '@/utils/formatNumber';

export function formatTokenAmount(
  value: number | string,
  decimals?: number,
): string;
export function formatTokenAmount(
  value: number | string,
  decimals: number,
  options: { type: 'number' },
): number;
export function formatTokenAmount(
  value: number | string,
  decimals?: number,
  options?: { type?: 'string' | 'number' },
): string | number {
  const val = Number(value) / 10 ** (decimals ?? 1);

  if (options?.type === 'number') {
    return val;
  }

  return formatNumber(val);
}
